"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentSummary = void 0;
const lodash_1 = require("lodash");
const common_1 = require("../common");
const entries_1 = require("../entries");
var AssignmentSummary;
(function (AssignmentSummary) {
    function create(meta, allEntries) {
        const entries = entries_1.AssignmentEntry.filterByStatus(allEntries, ['default', 'left']);
        // calculate summary
        let countSeen = 0, percentage = 0, submittedCount = 0, gradedCount = 0;
        // calculate the calculated fields.
        entries.forEach((entry) => {
            if ((0, lodash_1.gt)(entry.seenAt, 0) || entries_1.AssignmentEntry.isAnyPinSeen(entry))
                countSeen++;
            if (entries_1.AssignmentEntry.isTestPhase(entry, 'done'))
                submittedCount++;
            if (common_1.Grade.isGrade(entry.testData && entry.testData.grade))
                gradedCount++;
            percentage += entries_1.AssignmentEntry.calcPercentagePinsDone(entry);
        });
        const phaseCounts = entries_1.AssignmentEntry.countPhases(entries);
        const earliestPhase = common_1.TestPhase.earliestTestPhase(phaseCounts);
        const numberOfUsers = entries.length;
        const summary = {
            ...(meta.summary || AssignmentSummary.empty()),
            isActive: common_1.TestPhase.isLive(earliestPhase),
            phaseCounts: phaseCounts,
            isDirty: false,
            gradedCount,
            numberOfUsersSeen: countSeen,
            submittedCount: submittedCount,
            numberOfUsers,
            percentagePinsDone: numberOfUsers === 0 ? 0 : Math.round(percentage / numberOfUsers),
        };
        return summary;
    }
    AssignmentSummary.create = create;
    function empty() {
        // why 2015???????
        const d = new Date('2015-01-01 01:00:00');
        return {
            modifiedAt: Date.now(),
            numberOfUsers: 0,
            numberOfUsersSeen: 0,
            percentagePinsDone: 0,
            submittedCount: 0,
            gradedCount: 0,
            isDirty: true, // default, this summary is dirty, upon request is can will be updated
            dirtyDate: d.getTime(),
            isActive: true,
        };
    }
    AssignmentSummary.empty = empty;
})(AssignmentSummary || (exports.AssignmentSummary = AssignmentSummary = {}));
//# sourceMappingURL=AssignmentSummary.js.map